export default __webpack_public_path__ + "static/media/03f_fold-18.927a4627.mp4";